import { Component, Input } from '@angular/core';

import { Utils } from '@shared/utils/utils';

@Component({
  imports: [],
  selector: 'aux-checklist-row-info-gather-invoices',
  styleUrls: ['../../quarter-close-checklist.component.scss'],
  templateUrl: './checklist-row-info-gather-invoices.component.html',
})
export class ChecklistRowInfoGatherInvoicesComponent {
  @Input() amountInvoiced = Utils.zeroHyphen;
  @Input() isLoadingList = false;
  @Input() numberOfInvoices = Utils.zeroHyphen;
}
